module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discount-page"
  }, [(_vm.discountData) ? _c('div', {
    staticClass: "discount-inner"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [(!_vm.isLoading) ? _c('h1', [_vm._v("Get " + _vm._s(_vm.discountData.discount) + "% off")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("12 months of Low Carb Program")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "pricing"
  }, [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "pricing-inner"
  }, [_c('div', {
    staticClass: "receipt-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', [_vm._v("£" + _vm._s(_vm.originalCost))])])]), _vm._v(" "), _c('div', {
    staticClass: "receipt-row"
  }, [_c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', [_vm._v("Discount (" + _vm._s(_vm.discountData.discount) + "%)")])]), _vm._v(" "), _c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', [_vm._v("-£" + _vm._s(_vm.usersDiscount))])])]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "receipt-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', {
    staticClass: "bolder-right"
  }, [_vm._v("£" + _vm._s(_vm.calculatedCost))])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#5b617c",
      "margin-top": "1rem",
      "font-size": "14px"
    }
  }, [_vm._v("\n          *£" + _vm._s(_vm.calculatedCost) + " for one year, renewing at £" + _vm._s(_vm.originalCost) + ", billed annually\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "paypal-button w-inline-block",
    on: {
      "click": function($event) {
        return _vm.submitDiscount()
      }
    }
  }, [_c('div', {
    staticClass: "slider-right"
  }, [_vm._v("Subscribe now")])]), _vm._v(" "), _c('stripe-checkout', {
    ref: "sessionCheckoutRef",
    attrs: {
      "pk": _vm.publishableKey,
      "session-id": _vm.sessionId
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "greyText"
  }, [_vm._v("\n          The yearly membership gives you unlimited access to the Low Carb\n          Program's entire library of content and virtual events. You will be\n          charged £" + _vm._s(_vm.calculatedCost) + " for a 1 year subscription that will\n          renew at £" + _vm._s(_vm.originalCost) + ", billed annually.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "greyText"
  }, [_vm._v("\n          You may cancel your subscription at any time by going to your\n          Profile and following the instructions on the 'Manage Subscription'\n          page.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "greyText account"
  }, [_vm._v("\n          Upgrading account: "), _c('span', [_vm._v(_vm._s(_vm.discountData.email))])])], 1) : _vm._e()], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "static/logos/lcp-logo.svg",
      "alt": "Low Carb Program"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("\n            Embrace life-changing low carb lifestyle with expert-led education\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            Group and one-to-one virtual meetups with Low Carb Program experts\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            Browse 1,837 recipes and tailor meal plans to your preferences\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "testimonial"
  }, [_c('img', {
    attrs: {
      "src": "static/chrissy-after.jpg",
      "alt": "Chrissy"
    }
  }), _vm._v(" "), _c('span', [_vm._v("“My start weight was 105kg (16st 8 lbs) and now I weigh 80kg\n            (12st 9 lbs). I’ve had to buy a new wardrobe – I bought two pairs\n            of trousers last year that were too tight and now they’re falling\n            off me! I also have type 2 diabetes and it has helped my blood\n            sugars to come down”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', [_vm._v("Original cost per year")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "receipt-detail"
  }, [_c('p', {
    staticClass: "bolder-left"
  }, [_vm._v("Cost per year")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42a55992","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Discount/Discount.vue
// module id = 3141
// module chunks = 1